import { useContext } from "react";
import { SallerTableContainerContext } from "../contexts/sallerTableContext";

export const useSallerTable = () => {
  const context = useContext(SallerTableContainerContext);

  return context;
};
